import { useEffect, useMemo } from 'react';
import { useAtomValue, useSetAtom } from 'jotai/react';
import appConfig from 'app-config';
import AzarLoginModal from 'src/components/AzarOnly/Login';
import type { ModalLayoutProps } from 'src/components/ModalLayout';
import VividiLoginModal from 'src/components/VividiOnly/Login';
import useLogin from 'src/hooks/useLogin';
import { handleAgeRestrictedLoginAttemptAtom, isDeviceAgeRestrictedAtom } from 'src/stores/auth/atoms';
import { isRegisterCompleteAtom, resetRegisterAtom } from 'src/stores/register/atoms';
import type { EventLoginModalVisitorTrigger } from 'src/types/Event';
export interface LoginModalProps extends ModalLayoutProps {
  loginSuccessCallback?: () => void;
  trigger?: EventLoginModalVisitorTrigger;
  landFrom?: string;
}
export default function LoginModal({
  loginSuccessCallback,
  trigger,
  landFrom,
  ...modalLayoutProps
}: LoginModalProps) {
  const {
    isLogin
  } = useLogin();
  const isDeviceAgeRestricted = useAtomValue(isDeviceAgeRestrictedAtom);
  const isRegisterComplete = useAtomValue(isRegisterCompleteAtom);
  const handleAgeRestrictedLoginAttempt = useSetAtom(handleAgeRestrictedLoginAttemptAtom);
  const resetRegister = useSetAtom(resetRegisterAtom);

  // 회원가입/로그인 과정 중간에 다른 탭에서 로그인 등에 의해 로그인된 경우
  const isLoggedInWhileInProgress = useMemo(() => {
    // 회원가입 성공 마친 가이드라인 단계에서는 로그인상태지만 모달 노출 유지
    return isLogin && !isRegisterComplete;
  }, [isLogin, isRegisterComplete]);
  useEffect(() => {
    if (isDeviceAgeRestricted) {
      handleAgeRestrictedLoginAttempt();
    }
  }, [handleAgeRestrictedLoginAttempt, isDeviceAgeRestricted]);
  useEffect(() => () => {
    resetRegister();
  }, [resetRegister]);
  if (isDeviceAgeRestricted || isLoggedInWhileInProgress) return null;
  switch (appConfig.serviceCode) {
    case 'vividi':
      return <VividiLoginModal loginSuccessCallback={loginSuccessCallback} {...modalLayoutProps} />;
    case 'azar':
    default:
      return <AzarLoginModal loginSuccessCallback={loginSuccessCallback} trigger={trigger} landFrom={landFrom} {...modalLayoutProps} />;
  }
}